import React from "react";
import { strings } from "../localization";
import { primaryColor } from "../config/colors";

function OrderStatusContainer({ status }) {
  const getStatusColor = () => {
    let color = "#9E9E9E";
    let name = strings.unknown;
    const statusValue = status || "";
    const statusName = statusValue.toLowerCase();
    switch (statusName) {
      case "pending":
        color = "#FFA726";
        name = strings.pending;
        break;
      case "preparing":
        color = "#42A5F5";
        name = strings.preparing;
        break;
      case "complete":
        color = "#00b300";
        name = strings.delivered;
        break;
    }
    return { color, name };
  };

  return (
    <div
      pill
      className="px-3 py-2 text-white"
      style={{
        color: getStatusColor().color,
        backgroundColor: getStatusColor().color,
        border: "1px solid transparent",
        borderRadius: 200,
      }}
    >
      {getStatusColor().name}
    </div>
  );
}

export default OrderStatusContainer;
